module.exports = {
  // old
  // title: '天音视通——平台管理',
  // baseUrl: 'https://testp.tianyinvod.com', // 测试项目地址
  // baseApi: 'https://testy.tianyinvod.com', // 测试api请求地址 http://192.168.6.24:8787

  //
  // title: '天音视通——平台管理',
  // baseUrl: 'https://ytyls.tianyinsaas.cn', // 测试项目地址
  // baseApi: 'https://ytyls.tianyinsaas.cn', // 测试api请求地址
  // // baseUrl: 'http://114.55.62.115:8282', // 测试项目地址
  // baseApi: 'https://ytyls.tianyinsaas.cn', // 连锁版测试环境请求地址


  // //李红平
  // title: '天音视通——平台管理',
  // baseUrl: 'https://ytyls.tianyinsaas.cn', // 测试项目地址
  // // baseApi: 'https://ytyls.tianyinsaas.cn', // 测试api请求地址
  // // baseUrl: 'http://114.55.62.115:8282', // 测试项目地址
  // baseApi: 'http://192.168.6.74:6262', // 连锁版测试环境请求地址


    //李红平
    title: '天音视通——平台管理',
    baseUrl: 'http://36.111.156.180:2001', // 测试项目地址
    // baseApi: 'https://ytyls.tianyinsaas.cn', // 测试api请求地址
    // baseUrl: 'http://114.55.62.115:8282', // 测试项目地址
    baseApi: 'http://36.111.156.180:2001', // 连锁版测试环境请求地址


  // 新框架测试
  // title: '天音视通——平台管理',
  // baseUrl: 'http://newapi.tianyinsaas.cn', // 测试项目地址
  // baseApi: 'http://newapi.tianyinsaas.cn', // 测试api请求地址


};
